import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  IClaimWorkingQueueRow,
  ILiabilityWorkingQueueRow,
  IRecoveryWorkingQueueRow,
  IWorkingQueue,
} from './working-queues.models';

@Injectable({
  providedIn: 'root',
})
export class WorkingQueuesApiService {
  private readonly http = inject(HttpClient);

  private readonly baseUrl = environment.services.claims;

  public getClaimDashboard(): Observable<IWorkingQueue[]> {
    return this.http.get<IWorkingQueue[]>(
      `${this.baseUrl}/api/claims/working-queues`
    );
  }

  public getClaimFromWorkingQueue(
    queue: string
  ): Observable<IClaimWorkingQueueRow[]> {
    return this.http.get<IClaimWorkingQueueRow[]>(
      `${this.baseUrl}/api/claims/working-queues/${queue}`
    );
  }

  public deleteWorkingQueues(queue: string, ids: number[]): Observable<void> {
    return this.http.post<void>(
      `${this.baseUrl}/api/claims/working-queues/${queue}/remove`,
      ids
    );
  }

  public getRecoveryDashboard(): Observable<IWorkingQueue[]> {
    return this.http.get<IWorkingQueue[]>(
      `${this.baseUrl}/api/recoveries/working-queues`
    );
  }

  public getRecoveriesFromWorkingQueue(
    queue: string
  ): Observable<IRecoveryWorkingQueueRow[]> {
    return this.http.get<IRecoveryWorkingQueueRow[]>(
      `${this.baseUrl}/api/recoveries/working-queues/${queue}`
    );
  }

  public deleteRecoveryWorkingQueues(
    queue: string,
    ids: number[]
  ): Observable<void> {
    return this.http.post<void>(
      `${this.baseUrl}/api/recoveries/working-queues/${queue}/remove`,
      ids
    );
  }

  public getLiabilityDashboard(): Observable<IWorkingQueue[]> {
    return this.http.get<IWorkingQueue[]>(
      `${this.baseUrl}/api/liabilities/working-queues`
    );
  }

  public getLiabilitiesFromWorkingQueue(
    queue: string
  ): Observable<ILiabilityWorkingQueueRow[]> {
    return this.http.get<ILiabilityWorkingQueueRow[]>(
      `${this.baseUrl}/api/liabilities/working-queues/${queue}`
    );
  }

  public deleteLiabilityWorkingQueues(
    queue: string,
    ids: number[]
  ): Observable<void> {
    return this.http.post<void>(
      `${this.baseUrl}/api/liabilities/working-queues/${queue}/remove`,
      ids
    );
  }
}
